(ns web3.components.search
  (:require [web3.components.autocomplete :refer [autocomplete]]
            [web3.queries.root :as q-root]
            [web3.queries.asset :as q-asset]
            [web3.view :as v]
            [web3.utils :as utils]
            [reagent.core :as r]
            [web3.forms.validation :as validation]))

(defn search
  "Interface to the graphql /search endpoint, via autocomplete."
  [{:keys [key query validators value]
    :as props}]
  (let [{:keys [state]} (r/current-component)
        {:as query-result
         :keys [graphql/loading?]
         searchable-value? (and (:touched? @state)
                                (utils/some-str value)
                                (not (validation/invalid?
                                      (validation/validate-field
                                       validators value))))
         options :search} (when (and query (:touched? @state))
                            (query))]
    [autocomplete (v/merge-props (dissoc props :entity-type :depends-on :query)
                                 {:key key
                                  :spell-check "false"
                                  :on-focus #(swap! state assoc :touched? true)
                                  ;; set loading? to true if query-result is nil,
                                  ;; otherwise loading is temporarily nil whenever
                                  ;; a new search term is entered
                                  :loading? (or loading? (and searchable-value? (nil? query-result)))
                                  :options options})]))

(defn search-entities
  [{:keys [entity-type value value validators]:as props}]
  (let [{:keys [state]} (r/current-component)
        value (or value "")
        searchable-value? (and (:touched? @state)
                               (utils/some-str value)
                               (not (validation/invalid?
                                     (validation/validate-field
                                      validators value))))]
    (cond-> props
      searchable-value? (assoc :query #(q-root/search {:term value :type entity-type}
                                                      {:debounce-ms 1000}))
      true search)))


(defn search-models
  [{:keys [entity-type value depends-on validators]:as props}]
  (let [{:keys [state]} (r/current-component)
        value (or value "")
        searchable-value? (and (:touched? @state)
                               (utils/some-str value)
                               (not (validation/invalid?
                                     (validation/validate-field
                                      validators value))))
        number->value #(clojure.set/rename-keys % {:number :value})
        model-search (when searchable-value?
                       (fn []
                        (-> (q-asset/search-models {:model value :brand depends-on} {:debounce-ms 1000})
                            (update-in [:searchModels] (partial map number->value))
                            (#(assoc % :search (:searchModels %)))
                            (dissoc :searchModels))))]
    (-> props
        (cond-> depends-on       (assoc :query model-search)
                (not depends-on) (assoc :query #(q-root/search {:term value :type entity-type} {:debounce-ms 1000})))
        search)))
